import { ChangeDetectorRef, Component, OnInit , signal} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { HandoverNotesService } from '../../../../../state/modules/handover-notes/handover-notes.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { HandoverNotesActionComponent } from '../../components/handover-notes-action/handover-notes-action.component';
import { HANDOVER_NOTES_TYPE, ORDER_BY_TYPE } from './handover-notes.constant';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';

@Component({
  standalone: false,
  selector: 'kt-handover-notes',
  templateUrl: './handover-notes.component.html',
  styleUrls: ['./handover-notes.component.scss']
})
export class HandoverNotesComponent extends ModalBaseClass implements OnInit {

  employee_id;
  shiftDetail;
  loading = signal(false);
  filterData;
  sort = false;
  handoverListData;
  totalCount;
  sortingPayload;
  permissionConstant = PERMISSION_CONSTANT;
  PermissionV2 = PERMISSIONV2
  employee_user_id;

  lastPayload = {
    page_number: 1,
    page_size: 20,
    sort: [
      {
        field: 'hand_over_note_modified_at',
        dir: 'desc',
      },
    ],
  };
  currentOrderBy = ORDER_BY_TYPE.Modified_Date;
  scrolledHandoverList = false;
  subscriptions: Subscription[] = [];
  orderByType = ORDER_BY_TYPE;
  handoverNotesType = HANDOVER_NOTES_TYPE;
  // Tabs variables
  tabs: any = [this.handoverNotesType.Active, this.handoverNotesType.Completed];
  /**
   * Indicates the active tab
   */
  activeTab = this.tabs[0];

  constructor(
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    public handoverNotesService: HandoverNotesService,
    public activeModal: NgbActiveModal,
  ) {
    super(modalService);
  }

  ngOnInit() {
  }

  /**
   * Refresh the Handover Note List
   */
  refreshHandler() {
    this.lastPayload.page_number = 1;
    this.handoverNotesService.reload.next({type: this.activeTab, reload: true });
  }

  /**
   * It is used for sorting the Handover Note List data
   * Can be sorted by Created Date or Modified Date
   * @param orderBy
   */
  orderByHandler(orderBy) {
    this.lastPayload.page_number = 1;
    this.currentOrderBy = orderBy;
    switch (orderBy) {
      case this.orderByType.Created_Date:
        this.sortingPayload = [
          {
            field: 'hand_over_note_created_at',
            dir: 'desc',
          },
        ];
        break;
      case this.orderByType.Modified_Date:
        this.sortingPayload = [
          {
            field: 'hand_over_note_modified_at',
            dir: 'desc',
          },
        ];
        break;
      default:
        this.sortingPayload = [
          {
            field: 'hand_over_note_modified_at',
            dir: 'desc',
          },
        ];
    }
  }

  /**
   * To open add handover notes popup
   */
  addClickHandler() {
    const modalRef = this.openPopUp(HandoverNotesActionComponent, { userId: this.employee_user_id, shiftDetail: this.shiftDetail },
      { centered: true, size: 'lg', keyboard: true, backdrop: 'static' },
    );
    modalRef.result.then((result) => {
      if (result && result === 'Submit') {
        this.handoverNotesService.reload.next({type: this.activeTab, reload: true });
      }
    });
  }

  /**
   * To move to the the given tab
   * @param activeTab
   */
  changeTab(activeTab) {
    this.activeTab = activeTab;
    this.cdr.detectChanges();
  }
}
